<template>
  <div>
    <user-image :img="imageUser"></user-image>
    <fondo-intro
      :siguiente="pasarSiguiente"
      :anterior="pasarSiguiente"
      :comenzar="comenzarJuego"
    ></fondo-intro>
    <h2 v-show="mostrarTexto1" class="no-seleccionable zoom-in-zoom-out">
      Te damos la bienvenida a
      <div class="palabra">
        <span>V</span><span>O</span><span>X</span><span>C</span><span>O</span
        ><span>M</span><span>P</span><span>,</span>
      </div>
      un lugar lleno de conocimiento y sorpresas.
    </h2>
    <h2 v-show="mostrarTexto2" class="no-seleccionable zoom-in-zoom-out">
      Cursa todos los módulos y refuerza algunos conceptos de Computación
      Gráfica.
    </h2>
    <div class="todo" v-if="mostrarTexto3">
      <h3 class="text1 animate__animated animate__fadeInUp animate__delay-1s">
        MULTIMEDIA EDUCATIVA
      </h3>
      <h5 class="text2 animate__animated animate__fadeInUp animate__delay-2s">
        presenta
      </h5>
      <svg class="no-seleccionable svg" viewBox="0 0 800 600">
        <symbol id="s-text">
          <text text-anchor="middle" x="50%" y="35%" class="text--line">
            VOXCOMP
          </text>
        </symbol>
        <g class="g-ants">
          <use xlink:href="#s-text" class="text-copy"></use>
          <use xlink:href="#s-text" class="text-copy"></use>
          <use xlink:href="#s-text" class="text-copy"></use>
          <use xlink:href="#s-text" class="text-copy"></use>
          <use xlink:href="#s-text" class="text-copy"></use>
        </g>
      </svg>
      <a
        v-if="mostrarEmpecemos"
        @click="empecemos()"
        class="boton animate__animated absolute text-black font-bold py-2 px-4 rounded"
        >¡EMPECEMOS!</a
      >
    </div>
    <button @click="anteriorModulos()" v-if="flecha" class="arrow left">
      <svg width="60px" height="80px" viewBox="0 0 50 80" xml:space="preserve">
        <polyline
          fill="none"
          stroke="#FFFFFF"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
          points="
	45.63,75.8 0.375,38.087 45.63,0.375 "
        />
      </svg>
    </button>
    <button v-if="flecha" @click="siguienteModulo()" class="arrow right">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="60px"
        height="80px"
        viewBox="0 0 50 80"
        xml:space="preserve"
      >
        <polyline
          fill="none"
          stroke="#FFFFFF"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
          points="
	0.375,0.375 45.63,38.087 0.375,75.8 "
        />
      </svg>
    </button>
    <div
      v-if="mod1"
      class="mod1 animate__animated animate__fadeInRight animate__delay-1s"
    >
      <h3>{{ modulo }}</h3>
      <p>{{ descripcionModulo }}</p>
      <a
        v-if="this.pasarSiguiente == 3"
        href="https://voxcomp-mul.netlify.app/"
      >
        Empezar
      </a>
      <router-link v-else :to="pathModulo">Empezar</router-link>
    </div>
    <!-- <barra-herramientas></barra-herramientas> -->
  </div>
</template>
<script>
// import BarraHerramientas from "../components/BarraHerramientas.vue";
import FondoIntro from "../components/FondoIntro.vue";
import UserImage from "../components/UserImage.vue";
// require("@/styles/intro.css");
// import { VertexNormalsHelper } from "three/examples/jsm/helpers/VertexNormalsHelper.js";
// import { VertexTangentsHelper } from "three/examples/jsm/helpers/VertexTangentsHelper.js";

export default {
  components: { FondoIntro, UserImage },
  name: "Intro",
  data() {
    return {
      mod1: false,
      flecha: false,
      mostrarTexto1: true,
      mostrarTexto2: false,
      mostrarTexto3: false,
      rotar: false,
      comenzarJuego: false,
      mostrarEmpecemos: false,
      pasarSiguiente: 0,
      modulo: "Sistemas de Coordenadas",
      descripcionModulo: "Ubicate en el espacio",
      pathModulo: "/sistema-de-coordenadas",
      decodeToken: null,
      imageUser:
        "https://cdn.pixabay.com/photo/2018/04/18/18/56/user-3331256__340.png",
    };
  },
  methods: {
    empecemos() {
      this.flecha = true;
      this.mod1 = true;
      const btn = document.querySelector(".svg");
      const txt = document.querySelector(".text1");
      const txt2 = document.querySelector(".text2");
      this.mostrarEmpecemos = false;

      btn.classList.remove("animate");
      // txt.classList.remove("animate__fadeOut");
      txt.classList.remove("animate__delay-1s");
      // txt.classList.remove("animate__fadeOut");
      txt2.classList.remove("animate__delay-2s");
      console.log("buenas");
      setTimeout(() => {
        btn.classList.add("animate");
        txt.classList.add("animate__fadeOut");
        txt2.classList.add("animate__fadeOut");
        console.log("Start game");
        this.comenzarJuego = true;
      }, 100);
    },
    siguienteModulo() {
      this.pasarSiguiente += 1;
      console.log("desde intro", this.pasarSiguiente);
      if (this.pasarSiguiente >= 4) {
        this.pasarSiguiente = 0;
      }
      if (this.pasarSiguiente == 0) {
        this.modulo = "Sistemas de Coordenadas";
        this.descripcionModulo = "Ubicate en el espacio";
        this.pathModulo = "/sistema-de-coordenadas";
      } else if (this.pasarSiguiente == 1) {
        this.modulo = "Transformaciones 3D ";
        this.descripcionModulo = "Conoce tus nuevos poderes";
        this.pathModulo = "/transformadas-3d";
      } else if (this.pasarSiguiente == 2) {
        this.modulo = "Paradigmas de Rotación 3D";
        this.descripcionModulo = "No todo es tan lindo";
        this.pathModulo = "/cuaterniones";
      } else if (this.pasarSiguiente == 3) {
        this.modulo = "Conectivismo";
        this.descripcionModulo =
          "Crea lo que tu quieras junto a otras personas ";
      }
    },
    anteriorModulos() {
      this.pasarSiguiente -= 1;
      console.log("desde intro", this.pasarSiguiente);
      if (this.pasarSiguiente < 0) {
        this.pasarSiguiente = 3;
      }
      if (this.pasarSiguiente == 0) {
        this.modulo = "Sistemas de Coordenadas";
        this.descripcionModulo = "Ubicate en el espacio";
        this.pathModulo = "/sistema-de-coordenadas";
      } else if (this.pasarSiguiente == 1) {
        this.modulo = "Transformaciones 3D ";
        this.descripcionModulo = "Conoce tus nuevos poderes";
        this.pathModulo = "/transformadas-3d";
      } else if (this.pasarSiguiente == 2) {
        this.modulo = "Paradigmas de Rotación 3D";
        this.descripcionModulo = "No todo es tan lindo";
        this.pathModulo = "/cuaterniones";
      } else if (this.pasarSiguiente == 3) {
        this.modulo = "Conectivismo";
        this.descripcionModulo =
          "Crea lo que tu quieras junto a otras personas ";
      }
    },
    profile() {
      this.decodeToken = this.$getDataProfile(
        localStorage.getItem("token")
      ).uid;

      var axios = require("axios");

      var config = {
        method: "get",
        url: `https://restserver-cg.onrender.com/api/usuarios/${this.decodeToken}`,
        headers: {},
      };

      axios(config)
        .then((response) => {
          console.log(response.data);
          this.imageUser = response.data.img;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  mounted() {
    if (
      !localStorage.getItem("token") ||
      localStorage.getItem("token") == "undefined"
    ) {
      this.$router.push("/");
      console.log("es indefinido");
    } else {
      this.profile();
      setTimeout(() => {
        this.mostrarTexto2 = true;
        this.mostrarTexto1 = false;
      }, 5000);
      setTimeout(() => {
        this.mostrarTexto3 = true;
        this.mostrarTexto2 = false;
      }, 10000);
      setTimeout(() => (this.mostrarEmpecemos = true), 5500);
    }
  },
};
</script>
<style scoped src="@/styles/intro.css"></style>
